import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import de from "./locales/de.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";

i18n.use(LanguageDetector).use(initReactI18next).init({
  resources: {
    en: { translation: en },
    "en-CA": { translation: en },
    "fr-CA": { translation: fr },
    "en-GB": { translation: en },
    "en-US": { translation: en },
    de: { translation: de },
    "de-DE": { translation: de },
    es: { translation: es },
    "es-MX": { translation: es },
    fr: { translation: fr }
  },
  fallbackLng: "en",
  supportedLngs: [
    "en", "en-CA", "fr-CA", "en-GB", "en-US",
    "de", "de-DE", "es", "es-MX", "fr"
  ],
  nonExplicitSupportedLngs: true,
  load: "currentOnly",
  interpolation: { escapeValue: false },
  detection: { order: ["navigator"], caches: [] },
  react: { useSuspense: false }
});

document.documentElement.lang = i18n.resolvedLanguage || "en";

export default i18n;
